var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-comment__wrap" }, [
    typeof _vm.comment != "undefined"
      ? _c("div", { staticClass: "c-comments__comment" }, [
          _c("img", {
            staticClass: "c-comments__img",
            attrs: { src: _vm.comment.user_avatar, alt: _vm.comment.user_name },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "c-comments__content" }, [
            _c("div", { staticClass: "c-comments__user" }, [
              _c("p", [
                _c("a", { attrs: { href: "/u/" + _vm.comment.user_name } }, [
                  _vm._v(_vm._s(_vm.comment.user_name)),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.comment.comment_created))]),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "u-m-t1 u-m-b1 c-comments__text",
              domProps: { innerHTML: _vm._s(_vm.comment.comment_text) },
            }),
            _vm._v(" "),
            _vm.comment.comment_image !== ""
              ? _c("p", { staticClass: "u-m-t1 u-m-b3" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.comment.comment_image,
                      alt: _vm.comment.user_name + "comment",
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            typeof _vm.comment != "undefined" &&
            typeof _vm.comment.comment_id != "undefined"
              ? _c("div", { staticClass: "c-comments__cta" }, [
                  _c("p", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.commentReply(_vm.comment.comment_id)
                          },
                        },
                      },
                      [_vm._v("Reply")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.saveCommentLike(_vm.comment.comment_id)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          class: { liked: _vm.userLiked > 0 },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "21",
                            viewBox: "0 0 24 21",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z",
                              stroke: "black",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.commentLikes))]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showReplyBox
      ? _c(
          "div",
          [
            _c("comment-box", {
              attrs: { "parent-id": _vm.comment.comment_id },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showViewMore && _vm.showAllReplies === false
      ? _c("div", { staticClass: "replies_outer u-m-b4" }, [
          _c(
            "a",
            {
              staticClass: "u-block u-p-t1",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showReplies(_vm.comment.comment_id)
                },
              },
            },
            [
              _vm._v(
                "View " +
                  _vm._s(_vm.comment.reply_count) +
                  " replies to this\n            comment…"
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showAllReplies
      ? _c(
          "div",
          _vm._l(_vm.comment.replies, function (reply) {
            return _c("comment-replies", {
              key: reply.comment_id,
              attrs: {
                reply: reply,
                first_username: _vm.comment.user_name,
                depth: 0,
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }